export const mailingAddressFragment = `
  fragment MailingAddressFragment on MailingAddress {
    id
    firstName
    lastName
    name
    address1
    address2
    city
    province
    provinceCode
    zip
    country
    countryCodeV2
    phone
    formatted
  }
`;
